module.exports = __webpack_public_path__ + "static/media/fairway-lake-hex.4a3feaca.png";